import React from 'react';
import PropTypes from 'prop-types';

import SrLink from 'client/components/SrLink/SrLink';

const SrRenterApplicationStatusUpdateJobsRow = ({
  to,
}) => (
  <SrLink
    className='SrRenterApplicationStatusUpdateJobsRow'
    to={to}
  >
    <div className='actionContainer'>
      <span className='actionLink' />
    </div>
    <div className='textContainer'>
      <span className='addRoommate'>Edit My Job &amp; Rent</span>
      <span className='addRoommateMessage'>
        This will restart the verifications
      </span>
    </div>
  </SrLink>
);

SrRenterApplicationStatusUpdateJobsRow.propTypes = {
  to: PropTypes.string.isRequired,
};

SrRenterApplicationStatusUpdateJobsRow.displayName = 'SrRenterApplicationStatusUpdateJobsRow';

export default SrRenterApplicationStatusUpdateJobsRow;
